import { useState } from "react";

import "./WinnerSubscribe.css";
import { CONFIG } from "../../../../../util/constants";
import { isValidEmail } from "../../../../../util/util";

const { SERVER_API } = CONFIG;

// Guests who just won are the likeliest to want tomorrow's puzzle
const WinnerSubscribe = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "sending" | "done" | "error">("idle");
  const valid = isValidEmail(email);

  const submit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!valid || status === "sending") return;
    setStatus("sending");
    // Keep the original channel (reddit, tiktok...) when there is one
    const refSource = localStorage.getItem("refSource") || "win_screen";
    const referralCode = localStorage.getItem("referralCode");
    try {
      const response = await fetch(`${SERVER_API}/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, refSource, referralCode }),
      });
      // 204 means the email was already subscribed - treat as success too
      setStatus(response.ok || response.status === 204 ? "done" : "error");
    } catch (err) {
      setStatus("error");
    }
  };

  if (status === "done") {
    return (
      <div className="winner-subscribe" onClick={(e) => e.stopPropagation()}>
        <div className="winner-subscribe-title">📬 You're in!</div>
        <div className="winner-subscribe-text">Check your inbox. Tomorrow's puzzle arrives each morning.</div>
      </div>
    );
  }

  return (
    <form className="winner-subscribe" onSubmit={submit} onClick={(e) => e.stopPropagation()}>
      <div className="winner-subscribe-title">📬 Get tomorrow's puzzle by email</div>
      <div className="winner-subscribe-text">Read the news, then test your memory. One email a day, free.</div>
      <div className="winner-subscribe-row">
        <input
          type="email"
          inputMode="email"
          autoComplete="email"
          placeholder="you@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={status === "sending"}
        />
        <button type="submit" disabled={!valid || status === "sending"}>
          {status === "sending" ? "…" : "Subscribe"}
        </button>
      </div>
      {status === "error" && <div className="winner-subscribe-error">Something went wrong. Try again?</div>}
    </form>
  );
};

export default WinnerSubscribe;
